import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSiteAvailability } from '../site/SiteAvailability';
import { useCurrency } from '../keno/CurrencyContext';

export const useOriginalsAccess = (user) => {
  const site = useSiteAvailability();
  const currency = useCurrency();
  const owner = user?.id;
  const [status, setStatus] = useState(null), [error, setError] = useState('');
  const controller = useRef(null), sequence = useRef(0);
  const refresh = useCallback(async () => {
    if (!owner || !controller.current || controller.current.signal.aborted) return;
    const active = controller.current, request = ++sequence.current;
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/account/originals-access`, { headers: { Authorization: `Bearer ${localStorage.getItem('gv_token')}` }, signal: active.signal });
      if (!active.signal.aborted && request === sequence.current) { setStatus({ owner, ...data }); setError(''); }
    } catch (failure) { if (!axios.isCancel(failure) && !active.signal.aborted && request === sequence.current) setError('Unable to check Originals availability.'); }
  }, [owner]);
  useEffect(() => {
    controller.current = new AbortController(); setStatus(null); setError(''); refresh();
    const timer = setInterval(() => { if (!document.hidden) refresh(); }, 10000);
    window.addEventListener('focus', refresh);
    return () => { controller.current.abort(); clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [refresh]);
  const current = status?.owner === owner ? status : null;
  const demoDisabled = currency.accountDemo && currency.state && !currency.state.demo_enabled;
  return { blocked: Boolean(demoDisabled || site?.blocked || (owner && current?.blocked)), message: demoDisabled ? 'Demo Credits are disabled for this account or site.' : site?.blocked ? site.message : current?.message, until: current?.until, loading: Boolean(owner && ((!current && !error) || !currency.ready)), error: site?.error || (owner ? error : ''), refresh: () => { refresh(); site?.refresh(); currency.refresh(); } };
};